import {Component, OnDestroy, OnInit} from '@angular/core';
import {UnsavedChangesService} from '@services/unsaved-changes.service';
import {Subscription} from 'rxjs';
import {DispatcherService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

@Component({
  selector: 'si-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss']
})
export class UnsavedChangesDialogComponent implements OnInit, OnDestroy {
  displayDialog = false;
  dialogSubscription: Subscription;

  constructor(
    private unsavedChangesService: UnsavedChangesService,
    private dispatcher: DispatcherService
  ) {
  }

  ngOnInit() {
    this.dialogSubscription = this.unsavedChangesService.getDialogObservable().subscribe(displayDialog => {
      this.displayDialog = displayDialog;
    });

    // Closes the dialog if it is opened and the login session is being reset
    this.dispatcher.register('si-login-reset', this.onClickCloseDialog.bind(this, false), 'unsaved-changes-dialog');
  }

  onClickCloseDialog(acceptFlag: boolean): void {
    if (!this.displayDialog) {
      return;
    }

    this.unsavedChangesService.closeDialog(acceptFlag);
    this.closeDialog();
  }

  closeDialog(): void {
    this.displayDialog = false;
  }

  ngOnDestroy(): void {
    if (this.dialogSubscription) {
      this.dialogSubscription.unsubscribe();
    }

    this.dispatcher.unregisterFunction('si-login-reset', 'unsaved-changes-dialog');
  }
}
